var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-mengniu-annual-audit" }, [
    _c("div", { staticClass: "standard-size-16 color-gray-10" }, [
      _c(
        "div",
        { staticClass: "mb32 font-bolder" },
        [
          _vm._v("\n      计划详情\n      "),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "nowrap mh2 flex-center", attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "color-gray-7" }, [
                    _vm._v("年度："),
                  ]),
                  _c(
                    "div",
                    { staticClass: "yxtbiz-mengniu-annual-audit_ellipsis" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.projectInfo.year || "--") +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "nowrap mh2 flex-center", attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "color-gray-7" }, [
                    _vm._v("计划级别："),
                  ]),
                  _c("yxtf-tag", { attrs: { size: "small" } }, [
                    _vm._v(_vm._s(_vm.projectInfo.plan_level || "--") + "级"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "nowrap mh2 flex-center", attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "color-gray-7" }, [
                    _vm._v("所属组织："),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    {
                      attrs: {
                        "open-filter": true,
                        content: _vm.projectInfo.dept_name,
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-mengniu-annual-audit_ellipsis" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.projectInfo.dept_name || "--") +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "nowrap mh2 flex-center", attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "color-gray-7" }, [
                    _vm._v("专业线："),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    {
                      attrs: {
                        "open-filter": true,
                        content: _vm.projectInfo.professional_line_name,
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-mengniu-annual-audit_ellipsis" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.projectInfo.professional_line_name || "--"
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "nowrap mh2 flex-center", attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "color-gray-7" }, [
                    _vm._v("负责人："),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    {
                      attrs: {
                        "open-filter": true,
                        content: _vm.projectInfo.owner_name,
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-mengniu-annual-audit_ellipsis" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.projectInfo.owner_name || "--") +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.projectInfo.change_type_names
            ? _c(
                "yxtf-row",
                {
                  staticClass: "mv24 font-normal font-size-14",
                  attrs: { type: "flex" },
                },
                [
                  _c(
                    "yxtf-col",
                    {
                      staticClass: "nowrap mh2 flex-center",
                      attrs: { span: 24 },
                    },
                    [
                      _c("span", { staticClass: "color-gray-7" }, [
                        _vm._v("对比变化："),
                      ]),
                      _c(
                        "yxtf-tooltip",
                        {
                          attrs: {
                            "open-filter": true,
                            content: _vm.projectInfo.change_type_names,
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "yxtbiz-mengniu-annual-audit_ellipsis",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.projectInfo.change_type_names || "--"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.projectInfo.change_reason
            ? _c(
                "yxtf-row",
                {
                  staticClass: "mv24 font-normal font-size-14",
                  attrs: { type: "flex" },
                },
                [
                  _c(
                    "yxtf-col",
                    {
                      staticClass: "nowrap mh2 flex-center",
                      attrs: { span: 24 },
                    },
                    [
                      _c("span", { staticClass: "color-gray-7" }, [
                        _vm._v("变化原因描述："),
                      ]),
                      _c(
                        "yxtf-tooltip",
                        {
                          attrs: {
                            "open-filter": true,
                            content: _vm.projectInfo.change_reason,
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "yxtbiz-mengniu-annual-audit_ellipsis",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.projectInfo.change_reason || "--"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "yxt-row",
            { staticClass: "yxtbiz-project-audit__row", attrs: { gutter: 32 } },
            [
              _c(
                "yxt-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "yxt-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.goProjectDetail },
                    },
                    [_vm._v("查看详情")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }